import { AlertTriangle, X, Upload, Trash2, CheckCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

function DuplicateConfirmModal({ duplicateInfo, onConfirm, onCancel }) {
  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.2 }}
          className="bg-white rounded-2xl shadow-xl max-w-md w-full overflow-hidden"
          data-testid="duplicate-confirm-modal"
        >
          <div className="border-b border-slate-200 px-6 py-4 flex items-center justify-between bg-amber-50">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                <AlertTriangle className="w-5 h-5 text-amber-600" />
              </div>
              <h2 className="text-xl font-heading font-semibold text-slate-900">Duplicate Invoice Found</h2>
            </div>
            <button
              onClick={onConfirm}
              className="text-slate-400 hover:text-slate-600 transition-colors"
              data-testid="close-duplicate-modal"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="p-6">
            <p className="text-slate-700 mb-4">
              Your invoice has been processed, but we found a similar one already in the system:
            </p>
            
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 mb-4">
              <p className="text-sm font-medium text-slate-700 mb-2">Existing Invoice:</p>
              <p className="text-sm text-slate-600">
                {duplicateInfo.message || 'A similar invoice already exists.'}
              </p>
              {duplicateInfo.existing_invoice_date && (
                <p className="text-xs text-slate-500 mt-1">
                  Date: {duplicateInfo.existing_invoice_date}
                </p>
              )}
            </div>

            <p className="text-sm text-slate-600 mb-6">
              What would you like to do with the newly uploaded invoice?
            </p>

            <div className="flex space-x-3">
              <button
                onClick={onCancel}
                className="flex-1 px-4 py-2.5 bg-rose-50 text-rose-700 border border-rose-200 hover:bg-rose-100 transition-all font-medium rounded-lg flex items-center justify-center space-x-2"
                data-testid="discard-duplicate-upload"
              >
                <Trash2 className="w-4 h-4" />
                <span>Discard</span>
              </button>
              <button
                onClick={onConfirm}
                className="flex-1 px-4 py-2.5 bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm hover:shadow-md transition-all font-medium rounded-lg flex items-center justify-center space-x-2"
                data-testid="keep-duplicate-upload"
              >
                <CheckCircle className="w-4 h-4" />
                <span>Keep Both</span>
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}

export default DuplicateConfirmModal;
